import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormControlName } from '@angular/forms';
import { Moment } from 'moment';
import * as _moment from 'moment';
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

const moment = (_moment as any).default ? (_moment as any).default : _moment;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
    parseInput: 'MM/YYYY',
    fullPickerInput: 'l LT',
    datePickerInput: 'MMM/YYYY',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  };

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },

    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
  ]
})
export class DateRangeComponent implements OnInit {


  startTime: FormControl;
  endTime: FormControl;
  currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  max;
  min;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DateRangeComponent>,
  ) {
    this.dialogRef.disableClose = true;
    this.startTime = new FormControl(moment());
    this.min = new Date(this.startTime.value.format());
    this.endTime = new FormControl(moment());
    this.max =  new Date(this.endTime.value.format());
   }

  ngOnInit() {
  }

  public chosenYearHandler(normalizedYear: Moment, dateTime: FormControl) {
    const ctrlValue = dateTime.value;
    ctrlValue.year(normalizedYear.year());
    dateTime.setValue(ctrlValue);
  }

  public chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>, dateTime: FormControl) {
    const ctrlValue = dateTime.value;
    ctrlValue.month(normalizedMonth.month());
    dateTime.setValue(ctrlValue);
    this.min = new Date(this.startTime.value.format());
    this.max =  new Date(this.endTime.value.format());
    this.max.setSeconds(this.max.getSeconds() + 360);
    datepicker.close();
  }

  public apply() {
    const model = {
      duration: this.countMonth(this.min, this.max),
      startTime: this.min,
      endTime: this.max,
    }

    this.dialogRef.close({
      timeRange:  model
    });
  }

  countMonth(min: Date, max: Date) {
    var months;
    months = max.getFullYear() !== min.getFullYear() ? (max.getFullYear() - min.getFullYear()) * 12 : 1;
    months -= min.getMonth();
    months += max.getMonth();
    return months <= 0 ? 0 : months;
  }

}
